<template>
  <button class="btn obituary flowers-cta" @click.prevent="trigger()">
    <span v-text="texts.common.buyFlowers" />
  </button>
</template>

<script>
import { EventBus } from '../../event-bus';

export default {
  name: 'FlowerCTA',

  data() {
    return {
      texts: lavendlaObituary,
    };
  },

  methods: {
    trigger() {
      EventBus.emit('navigate-to', this.texts.currentEvents.flowerNavLabel);
    },
  },
};
</script>
